module.exports = __webpack_public_path__ + "img/partner-title.027adba.png";